// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"2f38f700","457":"9906d20e","488":"59ee2909","856":"be6edada"}[chunkId] + ".chunk.js";
};